<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>视光配镜</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.producttype" @keyup.enter.native="clicksearch" placeholder="请输入产品类型" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.brand" @keyup.enter.native="clicksearch" placeholder="请输入品牌" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.suppliers" @keyup.enter.native="clicksearch" placeholder="请输入供应商" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.productname" @keyup.enter.native="clicksearch" placeholder="请输入商品名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.specifications" @keyup.enter.native="clicksearch" placeholder="请输入规格型号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.manage" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择上下架" value="-1"></el-option>
              <el-option label="已下架" value="0"></el-option>
              <el-option label="已上架" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.processcostmode" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择加工费模式" value="-1"></el-option>
              <el-option label="仅镜架自备才收加工费" value="0"></el-option>
              <el-option label="必然收加工费" value="1"></el-option>
              <el-option label="不收加工费" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.insurancemode" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择保险费模式" value="-1"></el-option>
              <el-option label="无保险费选择项" value="0"></el-option>
              <el-option label="有保险费选择项" value="1"></el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="">
            <el-select v-model="keywords.isspike" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择是否开启秒杀" value="-1"></el-option>
              <el-option label="不开启" value="0"></el-option>
              <el-option label="开启" value="1"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickPiLiangXiaJia">批量下架</el-button>
            <el-button type="success" @click="clickexcel()">导出</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel"></TencentyunCosUploadExcel>
            注意：此处的批量导入仅仅是更新入库数量。
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Id" label="产品编号" min-width="4%"></el-table-column>
          <el-table-column prop="Producttype" label="产品类型" min-width="6%"></el-table-column>
          <el-table-column prop="Brand" label="品牌" min-width="6%"></el-table-column>
          <el-table-column prop="Suppliers" label="供应商" min-width="6%"></el-table-column>
          <el-table-column prop="Productname" label="商品名称" min-width="6%"></el-table-column>
          <el-table-column prop="Specifications" label="规格型号" min-width="6%"></el-table-column>
          <el-table-column prop="ManageName" label="上下架" min-width="6%">
            <template slot-scope="scope">
              <span v-if="scope.row.Manage === 1" style="color: #05bb74;">{{ scope.row.ManageName }}</span>
              <span v-if="scope.row.Manage === 0" style="color: #e95d4e;">{{ scope.row.ManageName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Units" label="计量单位" min-width="6%"></el-table-column>
          <el-table-column prop="Vin" label="入库数量" min-width="6%"></el-table-column>
          <el-table-column prop="Vout" label="出库数量" min-width="6%"></el-table-column>
          <el-table-column prop="Inventory" label="库存" min-width="6%"></el-table-column>
          <el-table-column prop="Retailprice" label="商品零售价" min-width="6%"></el-table-column>
          <el-table-column prop="Weight" label="商品重量(KG)" min-width="6%"></el-table-column>
          <el-table-column prop="Processcostmodename" label="加工费模式" min-width="6%"></el-table-column>
          <el-table-column prop="Processcostamount" label="加工费金额" min-width="6%"></el-table-column>
          <el-table-column prop="Insurancemodename" label="保险费模式" min-width="6%"></el-table-column>
          <el-table-column prop="Insuranceamount" label="保险费金额" min-width="6%"></el-table-column>
<!--          <el-table-column prop="Isspikename" label="秒杀状态" min-width="6%"></el-table-column>
          <el-table-column prop="Spikeprice" label="秒杀价" min-width="6%"></el-table-column> -->
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickModifyProcessCost(scope.row)">加工费</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickModifyInsurance(scope.row)">保险费</el-button>
              <!-- <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickModifySpike(scope.row)">秒杀</el-button> -->
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickModifyInfo(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 管理加工费 start -->
      <el-tab-pane label="管理加工费" name="four" disabled="disabled">
        <el-form :model="editProcessCost" ref="editProcessCostRef" label-width="170px">
          <el-form-item label="加工费模式" class="addAdminForm">
            <el-select v-model="editProcessCost.processcostmode" placeholder="请选择" style="width: 100%">
              <el-option label="仅镜架自备才收加工费" value="0"></el-option>
              <el-option label="必然收加工费" value="1"></el-option>
              <el-option label="不收加工费" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加工费金额" class="addAdminForm">
            <el-input v-model="editProcessCost.processcostamount"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSaveProcessCost">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 管理加工费 end -->

      <!-- 管理保险费 start -->
      <el-tab-pane label="管理保险费" name="five" disabled="disabled">
        <el-form :model="editInsurance" ref="editInsuranceRef" label-width="170px">
          <el-form-item label="保险费模式" class="addAdminForm">
            <el-select v-model="editInsurance.insurancemode" placeholder="请选择" style="width: 100%">
              <el-option label="无保险费选择项" value="0"></el-option>
              <el-option label="有保险费选择项" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保险费金额" class="addAdminForm">
            <el-input v-model="editInsurance.insuranceamount"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSaveInsurance">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 管理保险费 end -->

      <!-- 管理秒杀 start -->
<!--      <el-tab-pane label="管理秒杀" name="second" disabled="disabled">
        <el-form :model="editSpike" ref="editSpikeRef" label-width="170px">
          <el-form-item label="是否开启秒杀" class="addAdminForm">
            <el-select v-model="editSpike.isspike" placeholder="请选择" style="width: 100%">
              <el-option label="不开启" value="0"></el-option>
              <el-option label="开启" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="秒杀价" class="addAdminForm">
            <el-input v-model="editSpike.spikeprice"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSaveSpike">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane> -->
      <!-- 管理秒杀 end -->

      <!-- 商品信息 start -->
      <el-tab-pane label="商品信息" name="three" disabled="disabled">
        <el-form :model="editInfo" ref="editInfoRef" label-width="170px">
          <el-form-item label="上下架" class="addAdminForm">
            <el-select v-model="editInfo.manage" placeholder="请选择" style="width: 100%">
              <el-option label="下架" value="0"></el-option>
              <el-option label="上架" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品零售价" class="addAdminForm">
            <el-input v-model="editInfo.retailprice"></el-input>
          </el-form-item>
          <el-form-item label="商品重量(KG)" class="addAdminForm">
            <el-input v-model="editInfo.weight"></el-input>
          </el-form-item>
          <el-form-item label="入库数量" class="addAdminForm">
            <el-input v-model="editInfo.vin"></el-input>
          </el-form-item>
          <el-form-item label="商品图标" class="addAdminForm">
            <el-input v-model="editInfo.iconimage"></el-input>
          </el-form-item>
          <el-form-item label="简介图片" class="addAdminForm">
            <el-input v-model="editInfo.introduceimage"></el-input>
          </el-form-item>
          <el-form-item label="简介详情" class="addAdminForm">
            <el-input v-model="editInfo.introduceinfo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSaveInfo">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 商品信息 end -->

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel
  },
  name: 'MyOptometristInventory',
  data () {
    return {
      activeName: 'first',
      // 查询
      keywords: {
        shipmenttime: '',
        producttype: '',
        brand: '',
        suppliers: '',
        productname: '',
        specifications: '',
        processcostmode: '-1',
        insurancemode: '-1',
        isspike: '-1',
        manage: '-1'
      },
      editProcessCost: {
        id: '0',
        processcostmode: '',
        processcostamount: ''
      },
      editInsurance: {
        id: '0',
        insurancemode: '',
        insuranceamount: ''
      },
      editSpike: {
        id: '0',
        isspike: '',
        spikeprice: ''
      },
      editInfo: {
        id: '0',
        manage: '',
        retailprice: '',
        weight: '',
        vin: '',
        iconimage: '',
        introduceimage: '',
        introduceinfo: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiGetOptometristSuppliersNum()
    this.apiGetOptometristSuppliersList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetOptometristSuppliersNum()
      this.apiGetOptometristSuppliersList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetOptometristSuppliersList()
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImport('24022602',url)
    },
    clickModifyProcessCost(row) {
      this.activeName = 'four'

      this.editProcessCost.id = row.Id
      this.editProcessCost.processcostmode = row.Processcostmode.toString()
      this.editProcessCost.processcostamount = row.Processcostamount
    },
    clickModifyInsurance(row){
      this.activeName = 'five'

      this.editInsurance.id = row.Id
      this.editInsurance.insurancemode = row.Insurancemode.toString()
      this.editInsurance.insuranceamount = row.Insuranceamount
    },
    clickModifySpike(row) {
      this.activeName = 'second'

      this.editSpike.id = row.Id
      this.editSpike.isspike = row.Isspike.toString()
      this.editSpike.spikeprice = row.Spikeprice
    },
    clickexcel () {
      this.apiExcelOptometristInventory()
    },
    clickSaveSpike(){
      this.apiEditOptometristSuppliersSpike()
    },
    clickSaveProcessCost(){
      this.apiEditOptometristSuppliersProcessCost()
    },
    clickSaveInsurance(){
      this.apiEditOptometristSuppliersInsurance()
    },
    delaysearch () {
      var that = this
      setTimeout(function () {
        that.clicksearch()
      }, 2000)
    },
    clickModifyInfo(row) {
      this.activeName = 'three'

      this.editInfo.id = row.Id
      this.editInfo.manage = row.Manage.toString()
      this.editInfo.retailprice = row.Retailprice
      this.editInfo.weight = row.Weight
      this.editInfo.vin = row.Vin
      this.editInfo.iconimage = row.Iconimage
      this.editInfo.introduceimage = row.Introduceimage
      this.editInfo.introduceinfo = row.Introduceinfo
    },
    clickSaveInfo(){
      this.apiEditOptometristSuppliersInfo()
    },
    clickPiLiangXiaJia(){
      this.$confirm('确定要批量下架吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiPiLiangXiaJiaOptometristSuppliers()
      })
    },
    apiPiLiangXiaJiaOptometristSuppliers: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        suppliers: that.keywords.suppliers,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications,
        isspike: that.keywords.isspike,
        processcostmode: that.keywords.processcostmode,
        insurancemode: that.keywords.insurancemode,
        manage: that.keywords.manage
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_PiLiangXiaJiaOptometristSuppliers, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetOptometristSuppliersNum()
            that.apiGetOptometristSuppliersList()
          }
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristSuppliersNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        suppliers: that.keywords.suppliers,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications,
        isspike: that.keywords.isspike,
        processcostmode: that.keywords.processcostmode,
        insurancemode: that.keywords.insurancemode,
        manage: that.keywords.manage
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristSuppliersNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristSuppliersList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        suppliers: that.keywords.suppliers,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications,
        isspike: that.keywords.isspike,
        processcostmode: that.keywords.processcostmode,
        insurancemode: that.keywords.insurancemode,
        manage: that.keywords.manage
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristSuppliersList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristSuppliersSpike: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editSpike }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristSuppliersSpike, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristSuppliersNum()
            that.apiGetOptometristSuppliersList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristSuppliersProcessCost: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editProcessCost }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristSuppliersProcessCost, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristSuppliersNum()
            that.apiGetOptometristSuppliersList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristSuppliersInsurance: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editInsurance }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristSuppliersInsurance, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristSuppliersNum()
            that.apiGetOptometristSuppliersList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristSuppliersInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editInfo }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristSuppliersInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristSuppliersNum()
            that.apiGetOptometristSuppliersList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelOptometristInventory: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        suppliers: that.keywords.suppliers,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications,
        isspike: that.keywords.isspike,
        processcostmode: that.keywords.processcostmode,
        insurancemode: that.keywords.insurancemode,
        manage: that.keywords.manage
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelOptometristInventory, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImport: function (exceltype,url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        exceltype: exceltype,
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImport, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.delaysearch()
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
